import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useIntl } from 'react-intl';
export const useTranslation = (id, values, fallback)=>{
    const intl = useIntl();
    if (!intl.messages[id]) {
        return fallback || id;
    }
    return intl.formatMessage({
        id,
        defaultMessage: fallback
    }, values);
};
export const useTranslate = ()=>{
    const intl = useIntl();
    const translate = useCallback((id, values, fallback)=>{
        if (!intl.messages[id]) {
            return fallback || id;
        }
        return intl.formatMessage({
            id,
            defaultMessage: fallback
        }, values);
    }, [
        intl
    ]);
    return translate;
};
